import React from 'react';

import { Paper, Skeleton, Typography } from '@mui/material';

import { type ValueFormat, formatValue } from './cards';

type Props = {
  label: string;
  value: number | null;
  format: ValueFormat;
  loading?: boolean;
  note?: string;
};

export default function KpiTile({ label, value, format, loading, note }: Props) {
  return (
    <Paper data-lens-pdf-card variant="outlined" sx={{ p: 1.5, minWidth: 0, height: '100%' }}>
      <Typography
        variant="caption"
        color="text.secondary"
        component="div"
        title={label}
        sx={{
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 2,
          overflow: 'hidden',
          overflowWrap: 'anywhere',
        }}
      >
        {label}
      </Typography>
      {loading ? (
        <Skeleton width="70%" height={32} />
      ) : (
        <Typography variant="h6" component="div">
          {formatValue(value, format)}
        </Typography>
      )}
      {note && (
        <Typography variant="caption" color="text.secondary" component="div">
          {note}
        </Typography>
      )}
    </Paper>
  );
}
